import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import IntroBand from "./components/IntroBand";
import RatesSection from "./components/RatesSection";
import ValueSection from "./components/ValueSection";
import FlowSection from "./components/FlowSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <IntroBand />
        <RatesSection />
        <ValueSection />
        <FlowSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-card transition-all duration-300 hover:bg-primary-600 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
      </button>
    </div>
  );
}